import { render, staticRenderFns } from "./TrainingCommentsSide.vue?vue&type=template&id=32c44d1a&scoped=true&"
import script from "./TrainingCommentsSide.vue?vue&type=script&lang=js&"
export * from "./TrainingCommentsSide.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCommentsSide.vue?vue&type=style&index=0&id=32c44d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c44d1a",
  null
  
)

export default component.exports